import { ApiResponse } from '@nf/types/api';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { useApiBackendInfo } from '@/hooks/query/use-api-backend-info';
import { useQuery } from '@tanstack/react-query';
import queryKeys from '@/constants/query-keys';
import { useLicSettings } from '@/domains/config/hooks/use-lic-settings';
import { ApiBackendInfo } from '@/hooks/query/athena/types';
import { WcPromotionPrizeAmountDto } from './types';
import { WC_PROMOTION_PRIZE_AMOUNT_CACHE_MS } from './constants';

const fetchWcPromotionPrizeAmount = async (
	apiBackendInfo: ApiBackendInfo
): Promise<ApiResponse<WcPromotionPrizeAmountDto>> => {
	const response = await fetchComposer.getWithBearer(`${apiBackendInfo.url}/WcPromotion/GetWcPromotionPrizeAmount`)(apiBackendInfo.token);
	if (!response.ok) {
		throw new Error(`${response.status}: ${response.statusText}`);
	}
	return await response.json();
};

// 獲取獎池的獎金總額, 使用在 after party 中
export const useWcPromotionPrizeAmount = () => {
	const { enableWcPromotionAfterParty } = useLicSettings();
	const apiBackendInfo = useApiBackendInfo();

	const { data, isLoading, isError, error, refetch } = useQuery({
		queryKey: [
			queryKeys.WC_PROMOTION_PRIZE_AMOUNT,
			apiBackendInfo.url,
			apiBackendInfo.token
		],
		queryFn: () => fetchWcPromotionPrizeAmount(apiBackendInfo),
		staleTime: WC_PROMOTION_PRIZE_AMOUNT_CACHE_MS,
		cacheTime: WC_PROMOTION_PRIZE_AMOUNT_CACHE_MS,
		refetchInterval: WC_PROMOTION_PRIZE_AMOUNT_CACHE_MS,
		enabled: enableWcPromotionAfterParty && apiBackendInfo.isReady
	});

	return {
		data: data?.Data,
		isLoading,
		isError,
		error,
		refetch
	};
};
